import React from 'react';
import styles from './Header.module.scss';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '@/components/common/Button/Button';
import { HeaderRight } from './HeaderRight/HeaderRight';
import { useIsMobile } from '@/hooks';
import { ReactComponent as HamburgerIcon } from '@/assets/icons/navigation/hamburger.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/models';
import { toggleSidebar } from '@/store/reducers';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import clsx from 'clsx';
import { IMAGES } from '@/constants/ui/images';
import { ScreenName } from '@/constants/ui/screenName';

type HeaderProps = {
  shouldDisplayHeaderRight?: boolean;
  shouldDisplayBorder?: boolean;
  isWhiteBackground?: boolean;
  screenName?: ScreenName;
};

const Header: React.FC<HeaderProps> = ({
  shouldDisplayHeaderRight = true,
  shouldDisplayBorder = true,
  isWhiteBackground = false,
  screenName,
}) => {
  const { isTabletOrSmaller } = useIsMobile();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector(
    (state: RootState) => state.appData.sidebarMobileOpen
  );

  const toggleMenu = () => {
    dispatch(toggleSidebar(!isSidebarOpen));
  };

  const displayScreenName = screenName ? (
    <div className={styles.screenName}>{screenName}</div>
  ) : null;

  return (
    <header
      className={clsx(styles.header, isWhiteBackground && styles.headerWhite)}
    >
      <div
        className={clsx(
          styles.logoWrapper,
          !shouldDisplayBorder && styles.logoWrapperBorderless
        )}
      >
        <PublicImage
          className={styles.logo}
          src={`${IMAGES.PATHS.LOGOS}/logo-blocksite.svg`}
          alt={'BlockSite logo'}
          fetchPriority="high"
        />
        {displayScreenName}
        {shouldDisplayHeaderRight && isTabletOrSmaller && (
          <Button
            size={EButtonSize.md}
            hierarchy={EButtonHierarchy.neutral}
            buttonStyle={EButtonStyle.ghost}
            iconLead={HamburgerIcon}
            onClick={toggleMenu}
          />
        )}
      </div>
      {shouldDisplayHeaderRight && (
        <div className={styles.headerRightWrapper}>
          <HeaderRight />
        </div>
      )}
    </header>
  );
};

export default Header;
